<template>
  <div id="container">
    <header class="header">
      <sbheader class="sbheader"/>
    </header>
    <router-view/>
    <sbfooter class="sbfooter"/>
   
    <div class="audio-player-container">
      <AudioPlayer v-if="$store.state.songInfo.list.length"
        ref="audioPlayer"
        class="audio-player"
        :music="$store.state.songInfo.curIndex"
        :list="$store.state.songInfo.list"
        :playing="$store.state.songInfo.playing"
        :progress="$store.state.songInfo.progress"
        @indexChange="updateSongIndex"
        @playingChange="updatePlaying"
        @progressChange="updateProgress"
        @durationChange="item => $store.state.songInfo.list[$store.state.songInfo.curIndex].wksongduration = item"
      />
    </div>
    
    <login />
    <v-dialog />
    <modals-container class="modals-container"/>
    <!-- <modal name="goVerify" width="500" height="500">
        <div class="goVerify">
          <img src="./assets/icons/picon.png">
          <p>您还没有认证，认证成功才能上传作品哦~</p>
          <span>上传有效证件，简单两步快速认证。</span>

          <button @click="$router.push('/upload')">去认证</button>
        </div>
      </modal> -->
  </div>
</template>
<script>
  import sbheader from "@/views/Header.vue"
  import sbfooter from "@/views/Footer.vue"
  import AudioPlayer from "@/components/audioPlayer/AudioPlayer.vue"
  import Login from "@/components/Login.vue"
  import { request } from './utils.js'
  export default {
    components: {
      sbheader,
      sbfooter,
      AudioPlayer,
      Login,
    },
    methods: {
      updateSongIndex(idx) {
        this.$store.commit('updateSongIndex', idx)
      },
      updatePlaying(playing) {
        this.$store.commit('updatePlaying', playing)
      },
      updateProgress(val) {
        this.$store.commit('updateProgress', val)
      }
    },
    computed: {
      playing() {
          return this.$store.state.songInfo.playing;
      }
    },
    watch: {
      playing: function (val) {
        console.log(val)
        // val ? this.$refs.audioPlayer.play() : this.$refs.audioPlayer.pause()
      }
    },
    beforeCreate() {
      
    },
    mounted() {
      //  const { isSubmit } = this.$store.state
      //   console.log(isSubmit)
      //this.$modal.show('loginModal')
   
        this.$router.beforeEach((to, from, next) => {
          if (to.matched.some(record => record.meta.requiresAuth)) {
            if (!this.$store.state.userInfo.islogin) {
              this.$modal.show('loginModal')
              next(false)
              return
            }
          }
          if(to.matched.some(record => record.meta.verify)){
            if(!this.$store.state.userInfo.verify) {
              this.$modal.show('goVerify')
              next(false)
              return
            }
          }
         
    
          //   if(from.matched.some(record => record.meta.leaveConfirm)){
          //   if(!confirm("离开将丢失当前已填资料！")) {
          //     next(false)
          //     return
          //   }
          
          // }
          next()
        })
     
      // if(this.$route.path !== '/') this.$router.push('/')
      request('member/message/remind')
          .then(res => {
            if(res.success) {
              this.$store.state.userInfo.mewMessage = res.data.total ? true : false
            }
      })
      
    },
  }
</script>
<style lang="less">
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin:0; padding:0; } 
h1, h2, h3, h4, h5, h6{ font-size:100%; } 
address, cite, dfn, em, var { font-style:normal; } 
small{ font-size:12px; } 
ul, ol { list-style:none; } 
a { text-decoration:none; color: unset; } 
a:hover { text-decoration: unset; } 
sup { vertical-align:text-top; } 
sub{ vertical-align:text-bottom; } 
legend { color:#000; } 
fieldset, img { border:0; }
button, input, select, textarea { font-size:100%; outline: none;} 
table { border-collapse:collapse; border-spacing:0; } 


.heat {
  display: none!important;
}
.modal-backdrop .modal ul li {
    line-height: 2.52rem!important;
    height: 2.52rem!important;
    font-size: 1.56rem!important;
    cursor: pointer;
}
#container {
  font-family: 'PingFangSC', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-weight: bold;
  color: #000;
  input::placeholder {
    color: #A8A8A8;
  }
  .header {
    height: 80px;
    .sbheader {
      position: fixed;
      top: 0;
    }
  }
  .sbfooter {
    padding-bottom: 40px;
  }
  .audio-player-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    .audio-player {
      width: 1160px;
      margin: 0 auto;
    }
  }
  .v--modal {
    border-radius: 0;
  }
  .vue-form-generator {
    .form-group.error {
      .input {
        
      }
      .errors {
        color: #E76C7B;
        span {
          background-image: unset;
        }
      }
    }
  }
  .modals-container {
    .v--modal {
      background-color: unset;
      box-shadow: unset;
    }
  }
    .goVerify {
      text-align: center;
      font-weight: normal;
      img {
        width: 160px;
        height: 160px;
        margin: 76px auto 38px;
      }
      p {
        margin: auto;
        font-size: 18px;
        color: #000000;
      }
      span {
        display: block;
        margin: auto;
        width: 300px;
        margin-top: 16px;
        font-size: 14px;
        color: #666666;
      }
      button {
        margin-top: 60px;
        width: 420px;
        height: 40px;
        color: #fff;
        font-size: 14px;
        line-height: 40px;
        background: #40D77E;
        box-shadow: 0 12px 24px 0 rgba(64, 215, 126, 0.3);
        border-radius: 4px;
        border: none;
        cursor: pointer;
      }
    }
}
</style>
